import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { NationalProductsDetails } from '@/types/nationalProducts.types';

export const TextShorterCell = ({ row }: CellContext<NationalProductsDetails, unknown>) => {
  const isSmallScreen = window.innerWidth <= 768;
  return <span style={{ whiteSpace: isSmallScreen ? 'nowrap' : 'normal' }}>{row.original.variantDescription}</span>;
};
